import { gsap, TweenMax } from 'gsap/all'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger, TweenMax)

gsap.utils.toArray('[data-observe]').forEach((elem: HTMLElement) => {
  ScrollTrigger.create({
    // @ts-ignore
    trigger: elem,
    start: 'top 80%',
    end: 'bottom top',
    // markers: true,
    once: true,
    onEnter: () => {
      // @ts-ignore
      TweenMax.to(elem, 0.5, {
        opacity: 1,
        y: 0,
        duration: 1.25,
        onComplete: () => {
          elem.classList.add('show')
        },
      })
    },
  })
})
